import React from 'react';
import 'flag-icons/css/flag-icons.min.css';
import './CountryFlag.css';

const COUNTRY_CODE_ALIASES = {
  UK: 'GB',
  EL: 'GR',
};

function normalizeCountryCode(value) {
  const rawCode = String(value || '')
    .trim()
    .toUpperCase();

  const aliasedCode =
    COUNTRY_CODE_ALIASES[rawCode] || rawCode;

  return /^[A-Z]{2}$/.test(aliasedCode)
    ? aliasedCode
    : null;
}

export default function CountryFlag({
  countryCode,
  className = '',
}) {
  const normalized =
    normalizeCountryCode(countryCode);

  if (!normalized) {
    return null;
  }

  const lowerCode = normalized.toLowerCase();

  const classes = [
    'country-flag',
    'fi',
    `fi-${lowerCode}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      className={classes}
      aria-label={normalized}
      role="img"
      data-country-code={normalized}
      title={normalized}
    />
  );
}
